import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import InvestmentCalculator from "../../components/InvestmentCalculator";
import { toStartupAssets } from "../Calculator";

function toDealAssets(deals) {
  return (deals || [])
    .filter((d) => d.projection && d.projection.base)
    .map((d) => {
      const p = d.projection;
      return {
        id: d.deal_id,
        name: d.company,
        sublabel: `${d.sector} · ${d.round_label}`,
        kind: "deal",
        entries: [
          { id: "low", label: "Conservative", multiple: p.low, detail: `Conservative scenario over ${p.horizon}.` },
          { id: "base", label: "Base case", multiple: p.base, detail: `Base scenario over ${p.horizon}.` },
          { id: "high", label: "Optimistic", multiple: p.high, detail: `Optimistic scenario over ${p.horizon}.` },
        ],
      };
    });
}

export default function MemberCalculator() {
  const [tab, setTab] = useState("market");
  const [market, setMarket] = useState(null);
  const [deals, setDeals] = useState(null);

  useEffect(() => {
    api.get("/public/startups").then((r) => setMarket(toStartupAssets(r.data))).catch(() => setMarket([]));
    api.get("/deals").then((r) => setDeals(toDealAssets(r.data))).catch(() => setDeals([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const tabCls = (t) => `t-label pb-1 border-b ${tab === t ? "border-[#E8E6E1] !text-[#E8E6E1]" : "border-transparent hover:!text-[#E8E6E1]"}`;

  return (
    <div className="rise" data-testid="member-calculator-page">
      <span className="t-label">Model the outcome</span>
      <h1 className="t-h1 text-bone mt-3">Investment calculator</h1>
      <p className="t-small text-muted-s mt-2 measure">
        Model returns on the wider private market, or on Solera's own deals using our low, base and optimistic scenarios.
        Every figure is illustrative and is not a forecast or a promise of any outcome.
      </p>

      <div className="flex gap-8 mt-8">
        <button onClick={() => setTab("market")} className={tabCls("market")} data-testid="calc-tab-market">The market</button>
        <button onClick={() => setTab("deals")} className={tabCls("deals")} data-testid="calc-tab-deals">Solera deals</button>
      </div>

      <div className="mt-10">
        {tab === "market" ? (
          market === null ? <p className="t-label">Loading</p> :
            <InvestmentCalculator assets={market} testid="market-calc" />
        ) : (
          deals === null ? <p className="t-label">Loading</p> :
            deals.length === 0 ? (
              <p className="t-small text-muted-s hairline py-8" data-testid="no-deal-projections">
                No modelled deals yet. Solera adds conservative, base and optimistic scenarios to live deals. Check the Deals tab for what is open now.
              </p>
            ) : (
              <InvestmentCalculator
                assets={deals}
                testid="deals-calc"
                disclaimer="Scenarios are Solera's own conservative, base and optimistic estimates for illustration only. They are not forecasts, guarantees or investment advice. Private investments are illiquid and can lose their entire value."
                footer={
                  <p className="t-cap text-muted-s mt-6">
                    Open deals with a memo are listed under <Link to="/app/deals" className="link-plain">Deals</Link>.
                  </p>
                }
              />
            )
        )}
      </div>
    </div>
  );
}
